"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("../../api");
const constants_1 = require("../../constants");
const BusinessesActions_1 = require("./BusinessesActions");
const store_1 = require("../../store");
const AuthenticationActions_1 = require("../../authentication/AuthenticationActions");
function businesses(state = null, action) {
    switch (action.type) {
        case constants_1.ACTIONS.Businesses.LOAD_BUSINESSES:
            {
                api_1.doGet(api_1.API.v1.BUSINESSES.LIST).then(response => {
                    store_1.default.dispatch(BusinessesActions_1.loadBusinessesSuccess(response.data.businesses));
                }).catch(error => {
                    api_1.dispatchError(error, () => {
                        store_1.default.dispatch(BusinessesActions_1.loadBusinessesFailed(error.response.data));
                    });
                });
                return Object.assign({}, state, {
                    loadingProgress: constants_1.ProgressState.Loading
                });
            }
        case constants_1.ACTIONS.Businesses.UPDATE_BUSINESSES:
            {
                state.businesses.forEach(business => {
                    if (business._id === action.payload.businessId) {
                        business.createGroups = action.payload.group;
                    }
                });
                return Object.assign({}, state, {
                    loadingProgress: constants_1.ProgressState.Success,
                    businesses: state.businesses
                });
            }
        case constants_1.ACTIONS.Businesses.LOAD_BUSINESSES_SUCCESS:
            {
                return Object.assign({}, state, {
                    loadingProgress: constants_1.ProgressState.Success,
                    businesses: action.payload.businesses
                });
            }
        case constants_1.ACTIONS.Businesses.LOAD_BUSINESSES_FAILED:
            {
                return Object.assign({}, state, {
                    loadingProgress: constants_1.ProgressState.Failed,
                    businesses: null
                });
            }
        case constants_1.ACTIONS.Businesses.SET_BUSINESS:
            return Object.assign({}, state, {
                business: action.payload
            });
        case constants_1.ACTIONS.Authentication.LOGOUT:
            store_1.default.dispatch(AuthenticationActions_1.deleteState());
            return state;
        case constants_1.ACTIONS.Authentication.DELETE_STATE:
            return constants_1.INITIAL_STATE.businesses;
        default:
            return state;
    }
}
exports.default = businesses;


//////////////////
// WEBPACK FOOTER
// ./client/src/app/business/BusinessesReducer.ts
// module id = 781
// module chunks = 0 1 2